import logoWhite from "../assets/images/logoWhite.svg"
import IconInst from "../assets/images/IconInst.svg"
import IconVK from "../assets/images/IconVK.svg"
import IconTG from "../assets/images/IconTG.svg"

function footer() {
  return (
    <div className='footer'>
      <img className='footer__logo' src={logoWhite} alt="Aqua Time" />
      <div className='footer__socials'>
        <a href="https://vk.com/aqua_time_surgut86"><img className='footer__socials-item' src={IconVK} alt="ВК" /></a>
        <a href="https://t.me/AQUA_TIME_86"><img className='footer__socials-item' src={IconTG} alt="ТГ" /></a>
      </div>
      <div className="footer__bottom">
        <p className='footer__bottom-text'>ИП Сидорова Дарья Евгеньевна</p>
        <p className='footer__year'>2025</p>
        <p className='footer__bottom-text'>ИНН 860224505103</p>
      </div>
    </div>
   );
}

export default footer;